import React from "react";
import robot1 from "../../../assets/robot1.png";
import questionMark from "../../../assets/questionMark.png";
import { AcordeonContent } from "../../Acordeon";

const faqItems = [
  {
    question: "¿Utilizar MEU Aliado CDT es seguro?",
    answer: "Somos una empresa independiente de los bancos, creada por y para personas comunes, que utiliza la tecnología para beneficiar a más colombianos a través del libre mercado y la competencia bancaria. Nuestra autonomía nos permite ofrecerte información objetiva y enfocada en tu beneficio. Estamos legalmente constituidos en Colombia, con representación legal, dirección física y una correcta declaración de impuestos. Operamos bajo el modelo legal de Referenciación Comercial, utilizado en sectores como seguros y bienes raíces. Los bancos nos reconocen como Agentes Comerciales externos, con contratos para promover sus productos. Trabajamos constantemente en entender cada banco y actualizar en tiempo real la información sobre tasas, montos y plazos, asegurándote precisión y confianza.",
  },
  {
    question: "¿Por qué elegir un banco aliado de MEU y no mi banco de confianza?",
    answer: "MEU selecciona entidades bancarias con tasas de interés competitivas para garantizarte la mejor rentabilidad posible. Muchas veces, los bancos más reconocidos ofrecen tasas inferiores debido a su estabilidad en el mercado, mientras que otros bancos pueden ofrecer mejores condiciones para atraer clientes.",
  },
  {
    question: "¿Abrir un CDT con MEU tiene algún costo?",
    answer: "No, abrir un CDT a través de MEU no tiene ningún costo adicional. Nuestra plataforma te permite acceder a los mejores rendimientos sin cargos ocultos.",
  },
  {
    question: "¿Por qué los bancos más reconocidos ofrecen menor rentabilidad?",
    answer: "Los bancos más grandes suelen ofrecer tasas de interés más bajas porque tienen una base de clientes estable y no necesitan atraer nuevos inversionistas con tasas elevadas. En cambio, bancos en crecimiento pueden ofrecer tasas más competitivas para captar clientes.",
  },
  {
    question: "¿Cómo consigno? ¿PSE?",
    answer: "El proceso de inversión en un CDT a través de MEU se realiza mediante transferencia bancaria o PSE (Pagos Seguros en Línea), garantizando una transacción rápida y segura.",
  },
  {
    question: "¿El valor que veo en la simulación es el valor final? ¿Incluye retención?",
    answer: "La simulación muestra un valor aproximado basado en la tasa de interés y el tiempo de inversión. Sin embargo, el valor final estará sujeto a retenciones y otros impuestos aplicables según la normatividad vigente.",
  },
  {
    question: "¿El CDT se cancela o renueva solo si no digo nada?",
    answer: "Depende del banco. Algunos bancos renuevan automáticamente el CDT con las nuevas condiciones del mercado, mientras que otros lo cancelan y depositan los fondos en tu cuenta. Es importante verificar con cada entidad.",
  },
  {
    question: "¿Cuánto es el tiempo mínimo y máximo para invertir en un CDT?",
    answer: "El tiempo mínimo suele ser de 30 días y el máximo puede extenderse hasta varios años, dependiendo de la entidad bancaria y sus condiciones.",
  },
  {
    question: "¿Cuánto es el monto mínimo y máximo para invertir en un CDT?",
    answer: "El monto mínimo varía según el banco, pero generalmente oscila entre $500.000 y $1.000.000 COP. No hay un límite máximo, pero depende de la capacidad del banco para captar recursos.",
  },
  {
    question: "¿Qué es el seguro Fogafín?",
    answer: "Fogafín es el Fondo de Garantías de Instituciones Financieras en Colombia, que protege los depósitos de los ahorradores en caso de que una entidad financiera entre en liquidación. Esto brinda mayor seguridad a tu inversión.",
  },
  {
    question: "¿Por qué me piden datos para ver la simulación?",
    answer: "Solicitamos algunos datos para ofrecerte una simulación personalizada basada en tu perfil de inversión. Esto nos permite brindarte información precisa y adaptada a tus necesidades.",
  }
];

export default function FAQSection() {
  return (
    <section className="relative bg-[#0346a4] text-white overflow-hidden">
      <img
        src={robot1}
        alt="Robot decorativo"
        className="absolute inset-0 z-0 opacity-10 w-full h-full object-cover"
      />
      <div className="relative z-10 flex flex-col lg:flex-row gap-10 px-6 sm:px-10 lg:px-16 py-12 lg:py-20">
        <div className="w-full lg:w-1/3 flex flex-col items-center lg:items-start text-center lg:text-left">
          <img
            src={questionMark}
            alt="Signo de pregunta"
            className="mb-6 w-32 h-32 sm:w-40 sm:h-40 lg:w-48 lg:h-48 rounded-full border-4 border-white/40"
          />
          <h2
            className="text-3xl sm:text-4xl font-bold my-6 leading-tight"
            style={{ textShadow: "2px 3px 4px rgba(0,0,0,0.4)" }}
          >
            Tu seguridad es lo más importante.
          </h2>
          <p
            className="text-2xl sm:text-3xl lg:text-4xl font-bold leading-tight"
            style={{ textShadow: "2px 3px 4px rgba(0,0,0,0.4)" }}
          >
            ¡Aquí respondemos tus preguntas!
          </p>
        </div>
        <div className="w-full lg:w-2/3">
          <AcordeonContent faqItems={faqItems} />
        </div>
      </div>
    </section>
  );
}
